import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreSelectors } from '@core/store/core.selectors';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../../features/revisione53/core/store/revisione53.reducers';
import { AuthService } from '@core/services/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    isLoginPage$: Observable<boolean>;
    isOnline$: Observable<boolean>;

    constructor(private router: Router, private store: Store<Revisione53State>, public authService: AuthService) {
        this.isLoginPage$ = this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd),
            map((e: NavigationEnd) => e.urlAfterRedirects === '/login')
        );
        this.isOnline$ = this.store.select(CoreSelectors.isOnline);
    }
}
